import { ObjectType } from "../customTypes/defined";

export const update = (prevState: ObjectType, newState: ObjectType) => ({
  ...prevState,
  ...newState,
});
